import React, { useState } from "react";
import { Input, Row, Typography, Divider, Form, Col, DatePicker } from "antd";
import TextArea from "antd/es/input/TextArea";

const { Text } = Typography;

export const DetailsForm = (props) => {
  const { useForm, loanProductDetails } = props;
  console.log(loanProductDetails);

  return (
    <Form layout="vertical" form={useForm}>
      <Row style={{ justifyContent: "space-between" }}>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Product Name</Text>} name={"name"}>
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Short Name</Text>} name={"shortName"}>
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Fund</Text>} name={"fundId"}>
            <Input className="of-bold-disable-input" disabled />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Start Date</Text>} name={"startDate"}>
            <Input disabled className="of-bold-disable-input" />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Close Date</Text>} name={"closeDate"}>
            <Input disabled className="of-bold-disable-input" />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>Include In Customer Loan Counter</Text>}
            name={"includeInBorrowerCycle"}
          >
            <Input
              disabled
              style={{ width: "100%", height: 35 }}
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>

        <Divider orientation="left" orientationMargin="0">
          {" "}
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={<Text>Description</Text>} name={"description"}>
            <TextArea
              style={{ width: "100%", height: "15vh" }}
              disabled
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
